const navigateToSpecifiedRPScreenUtil = ({
    screen,
    isBackButton,
    reportPaymentGridData,
    usageContainerRef,
    dispatch,
    setReportPaymentScreenName,
    getModifiedButtonVisibilities,
    myCaseResourceType,
    footerButtonStatuses,
    reportPaymentScreenName,
    submit,
    next,
    setFooterButtonStatuses,
    replenishmentPageVisibilityUsage,
}) => {
    const moveToReplenishScreen =
        reportPaymentGridData &&
        reportPaymentGridData.length > 0 &&
        reportPaymentGridData.some(
            (item) =>
                item?.isAdditionalCartEntry &&
                item?.isReplenishmentRequired &&
                item.salesOrg !== 'S030' &&
                !item?.cfn?.startsWith('B33') &&
                item.materialType !== 'DIEN' &&
                (item?.isBundleItem
                    ? item?.bundleItem &&
                      item?.bundleItem.length > 0 &&
                      !item?.bundleItem.every((child) =>
                          child?.cfn?.startsWith('B33')
                      )
                    : true)
        );
    if (screen === 'Replen' && (!moveToReplenishScreen || !replenishmentPageVisibilityUsage) && !isBackButton) {
        return;
    }
    usageContainerRef.current?.scrollTo(0, 0);
    if (isBackButton) {
        dispatch(
            setReportPaymentScreenName(
                screen === 'Review' && moveToReplenishScreen && replenishmentPageVisibilityUsage
                    ? 'Replenish'
                    : 'Report Payment'
            )
        );
    } else {
        dispatch(
            setReportPaymentScreenName(
                screen === 'Replen' ? 'Replenish' : 'Report Payment'
            )
        );
    }
    const modifiedButtonStatuses = getModifiedButtonVisibilities(
        myCaseResourceType,
        footerButtonStatuses,
        reportPaymentScreenName === 'Review' ? submit : next,
        next,
        true
    );
    setFooterButtonStatuses(modifiedButtonStatuses);
};

export default navigateToSpecifiedRPScreenUtil;